<template>
  <div class="home">
    <v-carousel
      hide-controls
      :hide-delimiters="hideCarouselsControls"
      :height="bannerHeight"
    >
      <v-carousel-item v-for="(item, i) in carousels" :key="i" :src="item.src">
        <v-layout
          align-center
          justify-center
          fill-height
          column
          light
          class="home-title"
        >
          <h1>{{ item.title }}</h1>
          <p class="index-title-text">{{ item.text }}</p>
        </v-layout>
      </v-carousel-item>
    </v-carousel>

    <v-container pa-0 pb-5>
      <v-layout column align-center justify-center>
        <h2>严选市场优质产品</h2>
        <p>多位保险师悉心甄选，同类产品中只选1至2款</p>
      </v-layout>
      <v-layout row wrap class="container-bg group-bg">
        <v-flex md9 sm12 xs12 mt-5 style="margin: 0 auto; paddingtop: 40px">
          <v-layout row wrap app-bg class="product-item">
            <v-flex class="productInfo">
              <img
                src="https://qihuibao-group.oss-cn-beijing.aliyuncs.com/web/product/image/202401/72c038ea-981f-4273-a83a-7d92e4f728e5.png"
              />
              <v-flex class="title">
                <div class="title-content">
                  <v-flex><h4>易才灵工保</h4></v-flex>
                  <v-flex class="company">众安在线财产保险股份有限公司</v-flex>
                </div>
                <div class="features">
                  <span
                    >承保区域：中华人民共和国境内（不包括香港、澳门、台湾地区）</span
                  >
                </div>
                <v-flex class="conditions">
                  <div class='left'>
                    <c-icon name="iconchenggong"></c-icon>
                    <span>承保工种：1-4类</span>
                  </div>
                  <a href="/product/new/detail/2049">
                    <v-btn class="card-btn" color="primary">查看详情</v-btn>
                  </a>
                </v-flex>
              </v-flex>
              <!-- <v-flex>
                <v-layout row align-end fill-height>
                  <a href="/product/new/detail/2049" class="nav-logo-link">
                    <v-btn class="card-btn mb-4" color="primary"
                      >查看详情</v-btn
                    >
                  </a>
                </v-layout>
              </v-flex> -->
              <!-- <v-img src="/images/index/bg-2.png" >
                  <v-layout column pt-4 pl-4 fill-height class="brb">
                   
                  </v-layout>
                   <v-flex>
                      <v-layout row align-end fill-height>
                        <a href="/product/new/detail/2049" class="nav-logo-link">
                          <v-btn class="card-btn mb-4" color="primary"
                          >查看详情</v-btn
                          >
                        </a>
                      </v-layout>
                    </v-flex>
                </v-img> -->
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <div class="server-wrap">
      <v-container pa-0>
        <v-layout column align-center justify-center class="light-text">
          <h2>专业与可靠的服务</h2>
          <p>精准匹配需求，优化保障体系</p>
        </v-layout>
        <v-layout row wrap>
          <v-flex d-flex xs12 md4 justify-center fill-height>
            <section>
              <v-img src="/images/index/service-img1-new.png"></v-img>
              <div class="service-item">
                <h5>全程管家式服务</h5>
                <h6>7*24小时全程跟踪响应，客户服务不等待</h6>
              </div>
            </section>
          </v-flex>
          <v-flex d-flex xs12 md4 justify-center fill-height>
            <section>
              <div class="service-item">
                <h5>高效协助理赔</h5>
                <h6>理赔材料准备引导，多维服务贴心护航</h6>
              </div>
              <v-img src="/images/index/service-img2-new.png"></v-img>
            </section>
          </v-flex>
          <v-flex d-flex xs12 md4 justify-center fill-height>
            <section>
              <v-img src="/images/index/service-img3-new.png"></v-img>
              <div class="service-item">
                <h5>产品定制化</h5>
                <h6>沉淀14年企业服务经验，专为企业与员工定制保障产品</h6>
              </div>
            </section>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <div class="app-bg">
      <v-container pa-0 pb-5>
        <v-layout column align-center justify-center>
          <h2>合作伙伴</h2>
        </v-layout>
        <v-layout row wrap xs12 justify-center>
          <v-flex v-for="(item, i) in partner" :key="i">
            <img :src="item.src" alt width="153" class="partner-img" />
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <Notice></Notice>
  </div>
</template>

<script>
import Notice from "./Notice.vue";
export default {
  data() {
    return {
      carousels: [
        // {
        //   src: "/images/index/banner-3-new1.jpg",
        //   title: "",
        //   text: "",
        // },
        {
          src: "/images/index/banner-1-new1.jpg",
          title: "企业员工保险服务专家",
          text: "易才集团旗下品牌",
        },
        {
          src: "/images/index/banner-2-new.jpg",
          title: "全程管家式服务",
          text: "用专业与可靠赢取您的信赖",
        },
      ],
      partner: [
        {
          src: "/images/partner/partner-img1.png",
        },
        {
          src: "/images/partner/partner-img2.png",
        },
        {
          src: "/images/partner/partner-img3.png",
        },
        {
          src: "/images/partner/partner-img4.png",
        },
        {
          src: "/images/partner/partner-img5.png",
        },
        {
          src: "/images/partner/partner-img6.png",
        },
        {
          src: "/images/partner/partner-img7.png",
        },
        {
          src: "/images/partner/partner-img8-new.png",
        },
        {
          src: "/images/partner/partner-img9.png",
        },
        {
          src: "/images/partner/partner-img10.png",
        },
        {
          src: "/images/partner/partner-img11.png",
        },
        // {
        //   src: "/images/partner/partner-img12.png"
        // },
        {
          src: "/images/partner/partner-img13.png",
        },
        // {
        //   src: "/images/partner/partner-img14.png"
        // },
        {
          src: "/images/partner/partner-img15.png",
        },
        {
          src: "/images/partner/partner-img16.png",
        },
        // {
        //   src: "/images/partner/partner-img17.png"
        // },
        {
          src: "/images/partner/partner-img18.png",
        },
      ],
      replaceGYB: false,
    };
  },
  components: { Notice },
  computed: {
    hideCarouselsControls() {
      return this.carousels.length < 2;
    },
    bannerHeight() {
      return this.$vuetify.breakpoint.name === "xs" ? 150 : 377;
    },
  },
  mounted() {
    if (new Date().getTime() > 1680278400000) {
      this.replaceGYB = true;
    }
  },
};
</script>
<style lang="scss">
.productInfo {
  padding: 20px;
  display: flex;
  .title {
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    .title-content {
      display: flex;
      justify-content: space-between;
      .company {
        text-align: right;
        color: #666;
        font-size: 18px;
        font-weight: normal;
      }
    }
  }
  .features {
    margin-top: 20px;
    font-size: 15px;
    color: #666;
    // line-height: 80px;
    span:before {
      content: "•";
      color: $primary-color;
      width: 5px;
      height: 5px;
      margin-right: 5px;
    }
  }
  .conditions {
    margin-top: 20px;

    display: flex;
    justify-content: space-between;
    .left {
      font-size: 15px;
      color: #666;
      // flex: 1;
      align-content: end;
    }
    a {
      align-content: end;
    }
  }
}
.home {
  h2 {
    font-size: 36px;
    margin-bottom: 15px;
    font-weight: 400;
    padding-top: 60px;
  }

  p {
    font-size: 18px;
    color: #666666;
    margin-bottom: 40px;
  }
  .index-title-text {
    font-size: 24px;
    color: #d1d1d1;
  }
  .home-title h1 {
    font-size: 40px;
    margin-bottom: 30px;
  }
}
.container-bg {
  width: 1200px;
  max-height: 420px;
  &.group-bg {
    background: url("/images/index/group-bg-new.png") no-repeat top center;
    background-size: contain;
    margin-bottom: 50px;
  }
  &.person-bg {
    background: url("/images/index/person-bg.png") no-repeat top center;
    background-size: contain;
  }
  h3 {
    font-size: 30px;
    text-align: center;
    color: #fff;
    font-weight: 600;
    writing-mode: vertical-lr;
    letter-spacing: 5px;
    margin: -40px 76px 0;
  }
  .product-item {
    // height: 370px;
    border-left: 1px solid #e0e0e0;
    border-right: 1px solid #e0e0e0;
    section {
      // height: 370px;
      padding: 40px 0 0 30px;
      box-sizing: border-box;
      border-right: 1px solid #e0e0e0;
      border-bottom: 1px solid #e0e0e0;
    }
    h4 {
      font-size: 24px;
      margin-bottom: 20px;
    }
    p {
      font-size: 16px;
      color: #666;
      margin-bottom: 0;
    }
  }
  .brb {
    border-right: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
  }
  .blt {
    border-left: 1px solid #e0e0e0;
    border-top: 1px solid #e0e0e0;
  }
}
@media screen and (max-width: 960px) {
  .container-bg {
    width: auto !important;
    max-height: 100% !important;
    .brb {
      border-right: 1px solid #e0e0e0;
      border-bottom: none;
    }
    &.group-bg,
    &.person-bg {
      background-image: none !important;
    }
    .product-item {
      height: 100% !important;
      justify-content: center;
      > .flex {
        border-top: 1px solid #e0e0e0;
      }
      > .flex:first-child {
        border-left: 1px solid #e0e0e0;
      }
    }
    h3 {
      color: #222;
      font-weight: 600;
      letter-spacing: 5px;
      writing-mode: horizontal-tb;
      margin: 0 !important;
    }
  }
  .small-item {
    border-right: 1px solid #e0e0e0;
    &:first-child {
      border-left: 1px solid #e0e0e0;
    }
  }
  .server-wrap {
    section {
      margin-bottom: 30px;
    }
  }
}
@media screen and (max-width: 600px) {
  .home-title {
    h1 {
      font-size: 28px !important;
    }
    p {
      font-size: 18px !important;
    }
  }
  .home {
    h2 {
      font-size: 26px;
      margin-bottom: 18px;
      font-weight: 400;
      padding-top: 50px;
    }

    p {
      font-size: 14px;
      color: #666666;
      margin-bottom: 18px;
    }
    h3 {
      font-size: 20px !important;
    }
  }
  .product-item {
    > .flex:nth-child(2) {
      border-left: 1px solid #e0e0e0;
    }
  }
  .small-item:nth-child(2) {
    border-left: 1px solid #e0e0e0;
  }
}
.server-wrap {
  width: 100%;
  height: 100%;
  background: url("/images/index/server-bg.png") no-repeat center center;
  background-size: cover;
  padding-bottom: 93px;
  p {
    margin-bottom: 53px;
    color: #fff;
  }

  section {
    max-width: 225px;
    background-color: #fff;
  }

  .service-item {
    text-align: center;
    padding: 20px 28px 27px;
    h5 {
      font-size: 16px;
      color: #222;
      margin-bottom: 12px;
      font-weight: 400;
    }
    h6 {
      font-size: 14px;
      color: #666;
      font-weight: normal;
    }
  }
}

.partner-img {
  margin: 0 25px;
  margin-bottom: 45px;
}
.v-btn:not(.v-btn--depressed):not(.v-btn--flat) {
  box-shadow: 0px 3px 1px -2px rgba(255, 255, 255, 0.2),
    0px 2px 2px 0px rgba(255, 255, 255, 0.14),
    0px 1px 5px 0px rgba(255, 255, 255, 0.12);
}
</style>
